import type { SidebarEntry } from '@carouselgg/nexus/sidebar'
import { Bell, CalendarDays, CircleUserRound, Gamepad2, IdCard, LockKeyhole, Trophy, Users } from '@carouselgg/nexus/icon'

/** Where each section of the account hub lives. Old routes redirect here. */
export const HUB_PATHS = {
  overview: '/settings',
  profile: '/settings/profile',
  games: '/settings/connections',
  signIn: '/settings/sign-in',
  teams: '/settings/teams',
  competitions: '/settings/competitions',
  notifications: '/settings/notifications',
  calendars: '/settings/calendars',
} as const

export interface HubCounts {
  /** Teams plus organizations you belong to. */
  memberships?: number
  /** Sign-in proofs still missing (email, phone, passkey). */
  signInMissing?: number
}

/**
 * The side nav's sections while you are inside the account hub. It replaces
 * the app's places (Home, News, Compete…) rather than sitting beside them, and
 * a "Back to …" link above it is the way out. Applications and invites are a
 * tab of Competitions.
 */
export function hubSections(counts: HubCounts = {}): SidebarEntry[] {
  const icon = 18
  return [
    {
      kind: 'section',
      id: 'hub-you',
      items: [
        { kind: 'item', id: 'hub-overview', label: 'Overview', to: HUB_PATHS.overview, end: true, icon: <CircleUserRound size={icon} /> },
        { kind: 'item', id: 'hub-profile', label: 'Public profile', to: HUB_PATHS.profile, icon: <IdCard size={icon} /> },
        { kind: 'item', id: 'hub-games', label: 'Games & accounts', to: HUB_PATHS.games, icon: <Gamepad2 size={icon} /> },
        {
          kind: 'item', id: 'hub-sign-in', label: 'Email & sign-in', to: HUB_PATHS.signIn,
          icon: <LockKeyhole size={icon} />,
          badge: counts.signInMissing ? { kind: 'count', value: counts.signInMissing } : undefined,
        },
      ],
    },
    {
      kind: 'section',
      id: 'hub-in',
      label: 'What you\'re in',
      items: [
        {
          kind: 'item', id: 'hub-teams', label: 'Teams & clubs', to: HUB_PATHS.teams,
          icon: <Users size={icon} />,
          badge: counts.memberships ? { kind: 'count', value: counts.memberships } : undefined,
        },
        { kind: 'item', id: 'hub-competitions', label: 'Competitions', to: HUB_PATHS.competitions, icon: <Trophy size={icon} /> },
      ],
    },
    {
      kind: 'section',
      id: 'hub-prefs',
      label: 'Preferences',
      items: [
        { kind: 'item', id: 'hub-notifications', label: 'Notifications', to: HUB_PATHS.notifications, icon: <Bell size={icon} /> },
        { kind: 'item', id: 'hub-calendars', label: 'Calendars', to: HUB_PATHS.calendars, icon: <CalendarDays size={icon} /> },
      ],
    },
  ]
}
